import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme?: Theme) => ({
  paper: {
    padding: 24,
    backgroundColor: "#FFF",
    borderColor: "#E8EAEF",
    borderRadius: "8px",
    marginBlockStart: 32,
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    textAlign: "center",
  },
  container: {
    gridGap: 8.5,
    marginBlock: "32px 30px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
  button: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    textTransform: "none",
    "& svg path": {
      fill: "#22D9BB",
    },
  },
}));
